<template>
  <div :class="headerClass">
    <slot name='default' />
  </div>
</template>

<script>
export default {
  name: 'HeaderElement',
  props: {
    blue: Boolean,
    red: Boolean,
    green: Boolean,
    yellow: Boolean,
    gray: Boolean
  },
  computed: {
    headerClass () {
      if (this.blue) return 'header-element blue';
      if (this.red) return 'header-element red';
      if (this.green) return 'header-element green';
      if (this.yellow) return 'header-element yellow';
      if (this.gray) return 'header-element';
      return 'header-element';
    }
  }
};
</script>

<style lang='scss' scoped>
  @import "../../utils/assets/stylesheets/variables.scss";

  .header-element {
    width: 100%;
    display: block;
    padding: $base-padding;

    background-color: $gray-lighten-2;
    color: $primary;
    font-weight: 600;

    border-radius: $border-radius;

    &.blue {
      background-color: $secondary-lighten-4 !important;
      color: $secondary !important;
    }

    &.yellow {
      background-color: $tertiary-lighten-3 !important;
      color: $tertiary-darken-1;
    }

    &.red {
      background-color: $error-lighten-2 !important;
      color: $error !important;
    }

    &.green {
      background-color: $positive-lighten-3 !important;
      color: $positive !important;
    }
  }
</style>
